import RadioGroup from "@p-ban/common/src/components/form/radio/RadioGroup"

import ESTIMATE_CONSTANT from "../../../../constant/estimateConstant"
import FIELD_NAMES from "../../../../constant/fieldNames"
import getDisplayCondition from "../../../../service/getDisplayCondition"
import type { OneClickFieldProps } from "../../../../types"
import OneClickField from "../../../components/1Click/form/OneClickField"
import OneClickFieldMessages from "../../../components/1Click/form/OneClickFieldMessages"
import OneClickFieldStack from "../../../components/1Click/form/OneClickFieldStack"
import Radio from "../../../components/1Click/form/Radio/Radio"

const パターン面 = ({ values, handlers, errors }: OneClickFieldProps) => {
  const { patternSide: shouldShow } = getDisplayCondition(values)

  return (
    <OneClickField isShow={shouldShow} legend="パターン面">
      <RadioGroup name={FIELD_NAMES.パターン面} selectedValue={values.patternSide} onChange={handlers.radio}>
        <OneClickFieldStack>
          <Radio value={ESTIMATE_CONSTANT.パターン面.L1面視のL2面.value}>L1面視のL2面</Radio>
          <Radio value={ESTIMATE_CONSTANT.パターン面.L1面視のL1面.value}>L1面視のL1面</Radio>
          <Radio value={ESTIMATE_CONSTANT.パターン面.L2面視のL1面.value}>L2面視のL1面</Radio>
          <Radio value={ESTIMATE_CONSTANT.パターン面.L2面視のL2面.value}>L2面視のL2面</Radio>
        </OneClickFieldStack>
      </RadioGroup>
      <OneClickFieldMessages error={errors?.patternSide} />
    </OneClickField>
  )
}

export default パターン面
